import _ from 'lodash';

const decToBin = (num) => {
  const binStr = _.padStart(num.toString(2), 8, '0');
  return binStr.split('').map(c => c === '1');
};

const binToDec = (bits) => {
  return parseInt(bits.map(b => b ? '1' : '0').join(''), 2);
};

const decToHex = (num) => {
  return _.padStart(num.toString(16), 2, '0').toUpperCase();
};

export default {
  decToBin,
  binToDec,
  decToHex,
};
